import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

const AuthHandler = ({ setIsLoggedIn, isAdmin }) => {
  const [isSignup, setIsSignup] = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const navigate = useNavigate();

  const getBackendUrl = () => {
    return window.location.hostname === 'localhost'
      ? process.env.REACT_APP_BACKEND_URL_LOCAL
      : process.env.REACT_APP_BACKEND_URL_PRODUCTION;
  };

  const apiBase = `${getBackendUrl()}/api/${isAdmin ? "admin" : "user"}`;

  const handleSignup = async () => {
    try {
      const response = await axios.post(`${apiBase}/signup`, { name, email, password });
      console.log(response.data); // Use the response for debugging or logging
      Swal.fire("Registration Request Sent", "Please wait for admin approval.", "info");
      setIsSignup(false);
    } catch (error) {
      console.error(error.response?.data?.message);
      Swal.fire("Signup Failed", error.response?.data?.message || "Invalid credentials", "error");
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${apiBase}/login`, { email, password });
      console.log('Login successful:', response.data);
  
      if (isAdmin) {
        localStorage.setItem('adminToken', response.data.token);
        localStorage.setItem('adminId', response.data.userId);
      } else {
        localStorage.setItem('userToken', response.data.token);
        localStorage.setItem('userId', response.data.userId);
      }
      Swal.fire("Login Successful", response.data.message, "success");
      navigate("/stocklist-tanayajewel")
      setIsLoggedIn(true);
    } catch (error) {
      console.error('Login error:', error.response?.data?.message);
      if (error.response?.status === 403) {
        Swal.fire("Login Failed", error.response.data.message, "error");
      } else {
        Swal.fire("Login Failed", error.response?.data?.message || "Invalid credentials", "error");
      }
    }
  };

  const handleForgotPassword = async () => {
    try {
      const response = await axios.post(`${apiBase}/forgot-password`, { email });
      Swal.fire("OTP Sent", response.data.message, "success");
      setIsForgotPassword(true);
    } catch (error) {
      console.error(error.response?.data?.message);
      Swal.fire("Failed", error.response?.data?.message || "Invalid email", "error");
    }
  };

  const handleResetPassword = async () => {
    try {
      const response = await axios.post(`${apiBase}/reset-password`, { email, otp, newPassword });
      Swal.fire("Password Reset Successful", response.data.message, "success");
      setIsForgotPassword(false);
    } catch (error) {
      console.error(error.response?.data?.message);
      Swal.fire("Failed", error.response?.data?.message || "Invalid OTP or email", "error");
    }
  };

  return (
    <div className="auth-container">
      {isSignup ? (
        <div className="form-container">
          <h2>Signup</h2>
          <input type="text" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} />
          <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          <button className='signup-button' onClick={handleSignup}>Signup</button>
          <p>Already have an account? <span onClick={() => setIsSignup(false)}>Login here</span></p>
        </div>
      ) : isForgotPassword ? (
        <div className="form-container">
          <h2>Reset Password</h2>
          <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input type="text" placeholder="OTP" value={otp} onChange={(e) => setOtp(e.target.value)} />
          <input type="password" placeholder="New Password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
          <button className='signup-button' onClick={handleResetPassword}>Reset Password</button>
          <p>Remember your password? <span onClick={() => setIsForgotPassword(false)}>Login here</span></p>
        </div>
      ) : (
        <div className="form-container">
          <h2>Login</h2>
          <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          <button className='signup-button' onClick={handleLogin}>Login</button>
          {!isAdmin && (
            <>
              <p>Don't have an account? <span onClick={() => setIsSignup(true)}>Signup here</span></p>
            </>
          )}
          <p>Forgot your password? <span onClick={handleForgotPassword}>Reset here</span></p>
        </div>
      )}
    </div>
  );
};

export default AuthHandler;